module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-matters-03-3ad05aceb30a31a0d3f0a0527286ef34.png";